import { useThemeSlice } from "../../../components/ui/StatusBadge.jsx";
import { Ico } from "../../../components/icons/icons.jsx";
import { AssetTypeColumnChips } from "./AssetTypeColumnChips.jsx";
import { getAssetTypeColumns } from "../assetTypeUtils.js";
import { detailActionBtnStyle } from "../accountDetailTheme.js";
import { schemaTableCell, schemaTableHeader } from "../../../components/ui/schemaTableStyles.js";

export function AssetTypeList({ items, ap, onEdit, onDelete }) {
  const { c, dark, accentHex: A } = useThemeSlice();

  return (
    <div style={{ overflow: "auto", flex: 1 }}>
      <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 13 }}>
        <thead>
          <tr style={{ background: c.hover }}>
            <th style={schemaTableHeader(c, ap, { width: "22%" })}>Name</th>
            <th style={schemaTableHeader(c, ap)}>Schema</th>
            <th style={schemaTableHeader(c, ap, { width: 88, textAlign: "center" })}>Fields</th>
            <th style={schemaTableHeader(c, ap, { width: 96, textAlign: "right" })}>Actions</th>
          </tr>
        </thead>
        <tbody>
          {items.map((row) => (
            <AssetTypeTableRow key={row.id} row={row} c={c} dark={dark} A={A} ap={ap} onEdit={onEdit} onDelete={onDelete} />
          ))}
        </tbody>
      </table>
    </div>
  );
}

function AssetTypeTableRow({ row, c, dark, A, ap, onEdit, onDelete }) {
  const columns = getAssetTypeColumns(row);
  const fieldCount = columns.length;

  return (
    <tr onMouseEnter={(e) => (e.currentTarget.style.background = c.hover)} onMouseLeave={(e) => (e.currentTarget.style.background = "transparent")} style={{ transition: "background .15s ease" }}>
      <td style={schemaTableCell(c)}>
        <div style={{ display: "flex", alignItems: "center", gap: 10, minWidth: 0 }}>
          <span style={{ width: 34, height: 34, borderRadius: 9, flexShrink: 0, display: "grid", placeItems: "center", background: dark ? `${A}22` : `${A}12`, border: `1px solid ${dark ? `${A}40` : `${A}28`}`, color: A, fontSize: 11, fontWeight: 800, letterSpacing: "0.02em" }}>
            {row.name.slice(0, 2).toUpperCase()}
          </span>
          <div style={{ minWidth: 0 }}>
            <div style={{ fontWeight: 700, color: c.text, fontSize: 13.5, lineHeight: 1.3 }}>{row.name}</div>
            <div style={{ fontSize: 10.5, color: c.sub, marginTop: 2 }}>{fieldCount === 0 ? "Empty schema" : `${fieldCount} field${fieldCount === 1 ? "" : "s"}`}</div>
          </div>
        </div>
      </td>
      <td style={{ ...schemaTableCell(c), verticalAlign: "top" }}><AssetTypeColumnChips columns={columns} /></td>
      <td style={{ ...schemaTableCell(c), textAlign: "center" }}>
        <span style={{ display: "inline-flex", minWidth: 28, height: 24, padding: "0 8px", borderRadius: 999, alignItems: "center", justifyContent: "center", fontSize: 11, fontWeight: 800, color: c.mid, background: c.hover, border: `1px solid ${c.cardBdr}` }}>{fieldCount}</span>
      </td>
      <td style={{ ...schemaTableCell(c), textAlign: "right" }}>
        <div style={{ display: "inline-flex", gap: 6 }}>
          <button type="button" aria-label={`Edit ${row.name}`} onClick={() => onEdit(row)} style={detailActionBtnStyle(ap)}>{Ico.pencil}</button>
          <button type="button" aria-label={`Delete ${row.name}`} onClick={() => onDelete(row)} style={detailActionBtnStyle(ap, "danger")}>{Ico.trash}</button>
        </div>
      </td>
    </tr>
  );
}
